export default __webpack_public_path__ + "static/media/check-mark.0ad34025.png";